// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

import { genericTelemetryClickDispatcher } from "@msnews/social-utils";

export interface DeleteMenuTelemetryObjects {
    yesButton: TelemetryObjectBase;
    cancelButton: TelemetryObjectBase;
    deleteMenu: TelemetryObjectBase;
}

export const deleteMenuTelemetryContracts = {
    /** Comments-Scenario-10d */
    yesButton: {
        name: "CommentDelete",
        behavior: TelemetryBehaviorType.Remove,
        content: {
            headline: "Yes",
            type: TelemetryContentType.Comment
        }
    },
    cancelButton: {
        name: "CommentDelete",
        behavior: TelemetryBehaviorType.Remove,
        content: {
            headline: "Cancel",
            type: TelemetryContentType.Comment
        }
    },
    /** Comments-Scenario-10c */
    deleteMenu: {
        name: "CommentDelete",
        content: { type: TelemetryContentType.Comment }
    }
};

export const deleteMenuTelemetryActionDispatchers = {
    genericClick: genericTelemetryClickDispatcher
};